import { useState } from "react";
import { CaretDown, Books } from "@phosphor-icons/react";

const arr = (x) => (Array.isArray(x) ? x : x ? [x] : []);

export default function EvidencePanel({ evidence, ceoSupplied = [], compact = true, testid }) {
  const [open, setOpen] = useState(false);
  const e = evidence || {};
  const supplied = [
    ...arr(e.evidence_supplied_by_ceo),
    ...ceoSupplied.map((c) => c.description + (c.file ? ` (document: ${c.file.filename})` : "")),
  ].filter(Boolean);

  const Block = ({ title, items, text }) => {
    const list = arr(items).filter(Boolean);
    if (!list.length && !text) return null;
    return (
      <div className="mb-3">
        <div className="overline mb-1">{title}</div>
        {text && <p className="text-sm leading-relaxed text-muted-foreground">{text}</p>}
        {list.length > 0 && (
          <ul className="space-y-1">
            {list.map((it, i) => (
              <li key={i} className="flex gap-2 text-sm leading-relaxed text-muted-foreground">
                <span className="mt-1 h-1 w-1 shrink-0 rounded-full bg-current opacity-50" />
                <span>{typeof it === "string" ? it : JSON.stringify(it)}</span>
              </li>
            ))}
          </ul>
        )}
      </div>
    );
  };

  return (
    <div className={compact ? "mt-4 border-t border-border pt-3" : ""}>
      <button
        data-testid={testid || "evidence-panel-toggle"}
        onClick={() => setOpen((o) => !o)}
        className="flex w-full items-center justify-between text-left"
      >
        <span className="flex items-center gap-2 overline">
          <Books size={13} weight="bold" /> Evidence panel
        </span>
        <CaretDown
          size={14}
          className="text-muted-foreground transition-transform duration-200"
          style={{ transform: open ? "rotate(180deg)" : "none" }}
        />
      </button>
      {open && (
        <div className="reveal mt-3 border-l-2 border-border pl-4">
          <Block title="Current evidence available" items={e.current_evidence_available} />
          <Block title="Current evidentiary basis" text={e.current_evidentiary_basis} />
          <Block title="Evidence gaps" items={e.evidence_gaps} />
          <Block title="Evidence that would most improve the representation" items={e.evidence_that_would_most_improve} />
          <Block title="Evidence supplied by the CEO" items={supplied.length ? supplied : ["None supplied yet."]} />
        </div>
      )}
    </div>
  );
}
